import { render, staticRenderFns, recyclableRender, components } from "./personnel.vue?vue&type=template&id=3c597188&scoped=true&"
var renderjs
import script from "./personnel.vue?vue&type=script&lang=js&"
export * from "./personnel.vue?vue&type=script&lang=js&"
import style0 from "./personnel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./personnel.vue?vue&type=style&index=1&id=3c597188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c597188",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/personnel/personnel.vue"
export default component.exports